// extracted by mini-css-extract-plugin
export var label = "CheckboxField-module--label--319d4";